export default __webpack_public_path__ + "portal/static/media/noData.51f45188.png";